import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { salesManagement } from "../../../config";
import { AllVendors, externalProductsQuery } from "../../../data/Axios/queries";

const base_url = salesManagement.uri;

const actions = {
  entity: "Vendors",
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: false,
    permission: "EditPermission",
  },
  showStatus:true,
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
    modelName: "productIds",
    inputObjectName: "bulkActivateDeactivateVendors",
  },
  showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Vendor Details"
  },
};

function ExternalProductsTable() {
  const ignore = ["isActive", "email"];
  return (
    <Box m="2px">
      <DynamicTable
        title="External Products"
        subtitle="Create, view oExternal Products"
        ignoreFields={ignore}
        query={externalProductsQuery}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default ExternalProductsTable;
